import { Directive } from '@angular/core';
import { AccordionService } from './accordion.service';

@Directive({
	selector: '[appAccordion]',
	standalone: true,
	providers: [AccordionService] // this ensures the accordion service is scoped to this directive and its children
})
export class AccordionDirective {
}